import { render, staticRenderFns } from "./CustomReportPage1.vue?vue&type=template&id=f5b87c80&scoped=true&"
import script from "./CustomReportPage1.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage1.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportPage1.vue?vue&type=style&index=0&id=f5b87c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b87c80",
  null
  
)

export default component.exports